<template>
  <div>
    <button :disabled="saving || formstate.$dirty" @click="goBackToPages">Organize Pages</button>
    <h3>Album Details</h3>
    <p>Use the options below to edit your album.</p>
    <vue-form :state="formstate" @submit.prevent>
      <div class="detailscontainer">
        <div>
          <validate tag="label">
            <span>Name *</span>
            <input v-model="model.name" required name="name" @blur="save" />

            <field-messages name="name">
              <div>&nbsp;</div>
              <div slot="required">Name is a required field</div>
            </field-messages>
          </validate>

          <validate>
            <div class="label">Pages per spread</div>
            <div>
              <input type="radio" v-model="model.pagesPerSpread" name="pagesPerSpread" value="1" @change="save" id="pages_per_spread_1"> <label class="ml-2" for="pages_per_spread_1">1</label>
              <input type="radio" v-model="model.pagesPerSpread" name="pagesPerSpread" value="2" @change="save" id="pages_per_spread_2" class="ml-4"> <label class="ml-2" for="pages_per_spread_2">2</label>
            </div>

            <field-messages name="pagesPerSpread">
              <div>&nbsp;</div>
            </field-messages>
          </validate>

          <validate>
            <div class="label">Privacy</div>
            <div class="hint">A private album can only be viewed by you</div>
            <input type="radio" v-model="model.isPrivate" name="isPrivate" value="true" @change="save" id="privacy_private"> <label class="ml-2" for="privacy_private">Private</label>
            <input type="radio" v-model="model.isPrivate" name="isPrivate" value="false" @change="save" id="privacy_public" class="ml-4"> <label class="ml-2" for="privacy_public">Public</label>

            <field-messages name="isPrivate">
              <div>&nbsp;</div>
            </field-messages>
          </validate>

          <validate>
            <div class="label">Album cover</div>
            <div class="v-owl">
              <div><img class="album-cover" :src="model.coverPageId ? album.pages.find(x => x.id === model.coverPageId).pictureUrl : albumCover" /></div>
              <div class="owl">
                <button v-if="!showThumbnails" @click="showThumbnails = !showThumbnails">Change</button>
                <button v-if="showThumbnails" @click="onClickCancelDone">{{ hasChangedThumbnailAtLeastOnce ? 'Done' : 'Cancel' }}</button>
                <button @click="removeThumbnail" v-if="model.coverPageId">Remove</button>
              </div>
            </div>
            <div v-if="showThumbnails">
              <div>Select thumbnail:</div>
              <AlbumThumbnails
                :pages="orderedPages"
                :pagesPerSpread="album.pagesPerSpread"
                :currentPageIndex="currentPageIndex"
                :currentPageId="model.coverPageId"
                :onClickItem="onThumbnailClick"
                itemType="page"
              />
            </div>
          </validate>
        </div>
        <div>
          <validate tag="label">
            <span>Notes</span>
            <textarea cols="50" rows="3" v-model="model.notes" name="notes" @blur="save" />

            <field-messages name="notes">
              <div>&nbsp;</div>
            </field-messages>
          </validate>

          <validate tag="label">
            <span>Credits</span>
            <textarea cols="50" rows="3" v-model="model.credits" name="credits" @blur="save" />

            <field-messages name="credits">
              <div>&nbsp;</div>
            </field-messages>
          </validate>

          <div class="status">
            <div class="success" v-if="saved">Saved!</div>
            <div class="error">{{saveError}}</div>
          </div>
        </div>
      </div>
    </vue-form>
  </div>
</template>

<script>
import axios from 'axios'
import { albumPages } from '../utils/routing'
import albumCover from '../../public/images/album-cover.png'
import AlbumThumbnails from './AlbumThumbnails'
import { orderPages } from '../utils'
export default {
  props: ['album', 'updateAlbum'],
  data() {
    return {
      formstate: {},
      model: {
        name: this.album.name,
        isPrivate: this.album.isPrivate,
        pagesPerSpread: this.album.pagesPerSpread,
        notes: this.album.notes,
        credits: this.album.credits,
        coverPageId: this.album.coverPageId,
      },
      saving: false,
      saved: false,
      saveError: null,
      albumCover,
      showThumbnails: false,
      currentPageIndex: orderPages(this.album.pages, this.album.pageOrders).findIndex(x => x.id === this.album.coverPageId),
      hasChangedThumbnailAtLeastOnce: false,
    }
  },
  computed: {
    orderedPages() {
      return orderPages(this.album.pages, this.album.pageOrders)
    },
  },
  methods: {
    save() {
      if (this.formstate.$valid) {
        this.saveError = null
        this.saving = true
        axios.patch('/api/albums/' + this.album.id, this.model).then(response => {
          const updatedAlbum = response.data.album
          this.updateAlbum(updatedAlbum)
          this.saved = true
          this.formstate._reset()
          setTimeout(() => this.saved = false, 2000)
        }).catch(error => {
          this.saveError = "There was an error while saving: " + error.message
        }).then(() => {
          this.saving = false
        })
      }
    },
    goBackToPages() {
      this.$router.push(albumPages(this.album))
    },
    onThumbnailClick(index, page) {
      this.currentPageIndex = index
      this.model.coverPageId = page.id
      this.hasChangedThumbnailAtLeastOnce = true
      this.save()
    },
    onClickCancelDone() {
      this.hasChangedThumbnailAtLeastOnce = false
      this.showThumbnails = false
    },
    removeThumbnail() {
      this.model.coverPageId = null
      this.save()
    },
  },
  components: {
    AlbumThumbnails,
  },
}
</script>

<style lang="stylus" scoped>
.album-cover
  max-width 200px

.hint
  font-weight normal
  font-size small
  font-style italic

label
  font-weight bold

  &.vf-field-invalid
    > div
      font-weight bold
      color palevioletred

.status
  font-weight bold

  .success
    color mediumseagreen

  .error
    color palevioletred

.detailscontainer
  display flex
  width 80%
  margin-top 35px

  > div:first-child
    padding-right 50px
    min-width 275px
    width 1325px

  > div:last-child
    width 60%

  span
      display block
      margin-bottom 5px

    input
      width 100%

    input[type=radio]
      width auto

  textarea
    width 100%
    min-height 100px

  label
    font-weight 300

    span
      font-weight bold

  .label
    font-weight bold
</style>
